module.exports = new __parcel__URL__("apply_c_zh-tw.f0a64242.webp").toString();